module.exports = __webpack_public_path__ + "static/media/landing-bg4.038af0de.jpg";